module.exports = __webpack_public_path__ + "static/media/Benefit.6cbec175.png";